import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import communal from './modules/communal'
import order from './modules/order'
import systems from './modules/systems'
import getters from './getters'
import auth from './modules/auth'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    app,
    user,
    communal,
    systems,
    auth,
    order
  },
  getters
})

export default store